var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000.04 1887.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;opacity:0.1;isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: -330.01,
    x2: 2000.04,
    y2: -330.01,
    gradientTransform: "translate(0 1274)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d4abe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#9055c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6b74d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#4c8fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#34a3f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#22b2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#18bafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#15bdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28bad5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M859.79,1803,4.39,60.7C-9.51,32.9,11.39,0,42.19,0h296.4c15.9,0,30.8,9,37.8,22.9l624.7,1264c55.7,113.4,216.8,113.4,272.5,0l622.7-1263c7-13.9,21.9-22.9,37.8-22.9h36.8c21.9,0,35.8,22.9,25.9,41.8L1132.39,1803c-55.7,113.3-216.9,113.3-272.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M859.79,1803,376.39,23.9C369.39,9,353.49,1,340.59,1H43.19C10.39,1-8.51,33.8,4.39,61.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1001.09,1287.8,4.39,60.7C-7.51,31.9,10.39,3,38.19,0h301.4c16.9,1,29.8,11.9,35.8,22.9Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVet);
export default __webpack_public_path__ + "static/media/vet.355a8d198c0428ddb5bdd7a64ec71fc6.svg";
export { ForwardRef as ReactComponent };